import React from 'react';
import { Outlet } from 'react-router-dom'

import cls from './Layout.module.scss';

interface ILayout {
    children?: React.ReactNode
}

export const LoginLayout = ({children}:ILayout) => (
            <div className={cls.login}>

                <div className={cls.content}>
                    <Outlet/>
                    {children}
                </div>

            </div>
    )